export default __webpack_public_path__ + "static/AGaramondPro-Italic-3b813e7fe6cbb426717231c559e9129b.otf";